import { useReactiveVar } from '@apollo/client'
import { ProductType, useProductTypeVar } from '../models/ProductType'

export const useProductTypeFn = (): ProductType => {
  return useReactiveVar(useProductTypeVar)
}
